<template>
  <ThemeDefaultLayoutPage
    :title="pageInfo?.topic || pageInfo?.title"
    :description="pageInfo?.description"
    :breadcrumbs="breadcrumbItem"
    :show-category="false"
    custom-padding="lg:!tw-py-11 !tw-py-6"
  >
    <div
      :class="
        dataAsync.addresses.length <= 0 || !contact.formEnabled
          ? 'tw-flex tw-flex-col tw-items-center tw-max-w-[564px] tw-mx-auto'
          : 'tw-grid tw-grid-cols-1 lg:tw-grid-cols-[7fr_7fr] tw-gap-x-[112px] tw-gap-5 lg:tw-gap-y-10'
      "
    >
      <!-- Contact Form -->
      <div
        v-if="contact.formEnabled"
        class="tw-w-full tw-order-last lg:tw-order-none"
      >
        <DisplayHTMLContent
          v-if="contact.description"
          :class="[
            'tw-text-mb-body lg:tw-text-dt-body tw-text-dark-gray tw-mb-4',
            isContactFormAndAddress ? 'tw-text-left' : 'tw-text-center',
          ]"
          :model-value="contact.description || ''"
        />
        <div :class="isContactFormAndAddress ? 'tw-px-0' : 'md:tw-px-6'">
          <FormContact
            :category-event-name="categoryEventName"
            :is-centered="!isContactFormAndAddress"
            :filled="false"
            outlined
            hide-bottom-space
            :labels="HEADER_INPUT"
            :error-messages="FORM_ERRORS"
            button-class="tw-w-2/5 !tw-rounded-lg"
          />
        </div>
      </div>

      <!-- Address Cards -->
      <div
        v-if="dataAsync.addresses.length > 0"
        :class="['tw-w-full tw-flex tw-flex-col tw-gap-6 md:tw-gap-0']"
      >
        <div
          v-for="(address, index) in dataAsync.addresses"
          :key="`address-${index}`"
        >
          <CardAddress
            :branch-name="address.branchName"
            :address="address.fullAddress"
            :phone-numbers="address.phoneNumbers"
            :line-id="address.lineId"
            :email="address.email"
            :map-embed="address.mapEmbed"
            :category-event-name="categoryEventName"
            custom-class="!tw-flex !tw-flex-col-reverse md:!tw-grid md:!tw-grid-cols-2"
          />
          <HorizontalLine
            v-if="index !== dataAsync.addresses.length - 1"
            custom-class="tw-hidden md:tw-block md:!tw-my-6"
          />
        </div>
      </div>

      <!-- No Data -->
      <LandingNoData
        v-if="!contact.formEnabled && dataAsync.addresses.length <= 0"
      />
    </div>
  </ThemeDefaultLayoutPage>
</template>

<script setup lang="ts">
import {
  HEADER_INPUT as INPUT_LABELS,
  ERROR_MESSAGES,
} from "~/constants/contact-us";
import type { Language } from "~/constants/language";

const {
  pageInfo,
  breadcrumbItem,
  contact,
  categoryEventName,
  dataAsync,
  isContactFormAndAddress,
} = await useContactUsPage();

const langStore = useLanguageStore();
const locale = (langStore.main?.code || "th") as Language;

const HEADER_INPUT = INPUT_LABELS[locale] || INPUT_LABELS.th;
const FORM_ERRORS = ERROR_MESSAGES[locale] || ERROR_MESSAGES.th;
</script>

<style scoped>
:deep(.q-textarea .q-field__control) {
  height: auto;
  min-height: 150px;
}

:deep(.q-field:not(.q-textarea) .q-field__control) {
  height: 40px;
  min-height: 40px;
  align-items: center;
}

:deep(.q-field__control) {
  border-radius: 8px;
}

:deep(.q-field__bottom) {
  padding-left: 0;
}

@media (max-width: 767px) {
  /* Hide input labels on mobile */
  :deep(.tw-body.tw-mb-1) {
    display: none;
  }
}
</style>
